import styled from "styled-components";

export const MainContainer = styled.div`
  position: fixed;
  box-sizing: border-box;
  width: 351px;
  margin-top: 6.25rem;
  height: calc(100% - 6.25rem);
  overflow-y: auto;
  background: #f0f4f8;
  scrollbar-color: #f0f4f8 white;
  scrollbar-width: 1px;
  z-index: 1;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const ToggleStrip = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 115px;
  padding: 0 32px;
  background: #c1e7fe;
`;

export const SideContent = styled.div`
  padding: 40px;
  font-family: Inter;

  & .MuiListItemButton-root {
    font-family: Inter;
  }
`;

export const buttonStyle = {
  width: "100%",
  height: "3.5rem",
  padding: "1rem",
  gap: "0.5rem",
  borderRadius: "0.5rem",
  backgroundColor: "#FFFFFF",
  fontFamily: "Inter",
  fontWeight: 700,
  fontSize: "1rem",
  lineHeight: "1.21rem",
};
